@if (iframeSrc) {
  <div class="container mx-auto max-w-640 pb-5">
    <iframe
      id="ytplayer"
      type="text/html"
      class="w-full video-player"
      [src]="iframeSrc"
      frameborder="0"
    ></iframe>
  </div>
}
